import { useState } from 'react';
import { useNavigate,Link } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from '../../utils/api';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import { useAuth } from '../../context/AuthContext';
import { Eye, EyeOff } from 'lucide-react';
const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
const { login } = useAuth();
  // const handleLogin = async (e) => {
  //   e.preventDefault();
  //   setLoading(true);

  //   try {
  //     const res = await axios.post(`${API_BASE_URL}/api/auth/login`, {
  //       email,
  //       password,
  //     });
  //     login(res.data.user);
  //     localStorage.setItem('token', res.data.token);
  //     toast.success('Login successful');
  //     navigate('/dashboard'); // Change to your protected route
  //   } catch (err) {
  //     toast.error('Invalid email or password');
  //   } finally {
  //     setLoading(false);
  //   }
  // };
const handleLogin = async (e) => {
  e.preventDefault();
  setLoading(true);

  try {
    const res = await axios.post(`${API_BASE_URL}/api/auth/login`, {
      email,
      password,
    });

    login(res.data.user);
    localStorage.setItem('token', res.data.token);
    toast.success('Login successful');
    navigate('/dashboard');
  } catch (err) {
    if (err.response?.status === 403) {
     if (err.response?.status === 403) {
               await Swal.fire({
                 icon: 'warning',
                 title: 'Subscription Expired',
                 html: 'Your subscription has expired. Please <b>subscribe</b> to continue using Sparks Scribe.',
                 showCancelButton: true,
                 confirmButtonText: 'Subscribe Now',
                 cancelButtonText: 'Logout',
                 confirmButtonColor: '#6C5DD3',
                 cancelButtonColor: '#d33',
               }).then((result) => {
                 if (result.isConfirmed) {
                   window.open('https://www.sparkscribe.ai/', '_blank');
                 }
               });
             }
    } else if (err.response?.status === 401) {
      toast.error('Invalid password');
    } else if (err.response?.status === 404) {
      await Swal.fire({
                       icon: 'warning',
                       title: 'Not Found',
                       html: 'You are not a subscriber. Please <b>subscribe</b> to continue using Sparks Scribe.',
                       showCancelButton: true,
                       confirmButtonText: 'Subscribe Now',
                       cancelButtonText: 'Logout',
                       confirmButtonColor: '#6C5DD3',
                       cancelButtonColor: '#d33',
                     }).then((result) => {
                       if (result.isConfirmed) {
                         window.open('https://www.sparkscribe.ai/', '_blank');
                       }
                     });
    } else {
      toast.error('Login failed');
    }
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0E0A1F] text-white px-4 font-sans">
      <div className="bg-[#1C1235] p-8 rounded-xl shadow-md w-full max-w-md text-white">
        {/* Logo */}
        <div className="flex justify-center mb-6">
          <img src="/Spark_01.png" alt="Sparks Logo" className="h-12" />
        </div>

        {/* Heading */}
        <h2 className="text-2xl font-bold font-poppins text-white mb-1 text-center">
          Welcome Back
        </h2>
        <p className="text-sm text-white text-center mb-6 font-light">
          Please log in to continue
        </p>

        {/* Form */}
        <form onSubmit={handleLogin} className="space-y-4">
  {/* Email */}
  <div>
    <label className="text-sm block mb-1 font-light text-white">Email</label>
    <input
      type="email"
      className="w-full p-3 border border-[#6D5BAF] rounded bg-white text-[#34304D]"
      value={email}
      onChange={(e) => setEmail(e.target.value)}
      required
    />
  </div>

  {/* Password with toggle */}
  <div className="relative">
    <label className="text-sm block mb-1 font-light text-white">Password</label>
    <input
      type={showPassword ? 'text' : 'password'}
      name="password"
      value={password}
      onChange={(e) => setPassword(e.target.value)}
      placeholder="Enter password"
      className="w-full p-3 pr-10 rounded bg-white text-black border border-[#3B2D5F]"
      required
    />

    <div
      className="absolute right-3 top-[65%] transform -translate-y-1/2 cursor-pointer"
      onClick={() => setShowPassword((prev) => !prev)}
    >
      {showPassword ? (
        <EyeOff className="text-[#34304D] w-5 h-5" />
      ) : (
        <Eye className="text-[#34304D] w-5 h-5" />
      )}
    </div>
  </div>

  {/* Submit button */}
  <button
    type="submit"
    disabled={loading}
    className="w-full py-3 rounded text-white font-semibold bg-[#6D5BAF] hover:bg-[#5a4aa5] transition"
  >
    {loading ? 'Logging in...' : 'Log In'}
  </button>
</form>

<p className="text-sm text-center text-gray-400">
  <Link to="/forgot-password" className="underline text-purple-400">Forgot Password?</Link>
</p>
        {/* Footer */}
        <p className="text-sm text-center mt-4 text-white font-light">
          Don’t have an account?{' '}
          <span
            onClick={() => navigate('/register')}
            className="cursor-pointer font-medium text-[#6D5BAF] hover:underline"
          >
            Sign up
          </span>
        </p>
      </div>
    </div>
  );
};

export default Login;
